// Dummy news data for the News section
// You can replace this with a fetch call later if needed
export const NEWS_ITEMS = [
  {
    id: "1",
    slug: "calyx-solutions-stands-for-migrant-communities-at-the-fca-meeting",
    title: "Calyx Solutions Stands for Migrant Communities at the FCA Meeting",
    date: "2025-10-14",
    image: "/assets/images/news/calyx-solutions-stands-for-migrant-communities-at-the-fca-meeting.jpg",
    excerpt:"At Calyx Solutions, we remain committed to addressing the challenges faced by high-risk...",
   
  },
];


